import React from "react";
import { Table } from "react-bootstrap";
import "../../../assets/styles/scheduledChanges.scss";

const statusLabels = {
  Approved: "Zaplanowane",
  Pending: "Do akceptacji",
  Rejected: "Odrzucone",
  Withdrawn: "Wycofane",
  Executed: "Wykonane",
  Queued: "W trakcie wykonywania",
  Failed: "Wystąpił błąd",
};

const detailRows = [
  { key: "createdAt", label: "Data dodania" },
  { key: "scheduledTime", label: "Data zaplanowania" },
  { key: "rollbackScheduledTime", label: "Data wycofania" },
  { key: "status", label: "Status" },
  { key: "terminalDr", label: "DR" },
  { key: "terminalEx", label: "EX" },
  { key: "requestedBy", label: "Użytkownik dodający" },
  { key: "approvedBy", label: "Użytkownik akceptujący" },
];

const dateFieldKeys = new Set([
  "createdAt",
  "scheduledTime",
  "rollbackScheduledTime",
]);

const formatDateTime = (value) => {
  if (value === null || value === undefined || value === "") return "-";

  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return String(value);

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");

  return `${year}-${month}-${day} ${hours}:${minutes}`;
};

const ScheduledChangeDetailData = ({ details = {} }) => {
  const resolveValue = (key) => {
    const value = details?.[key];
    if (value === null || value === undefined || value === "") return "-";

    if (dateFieldKeys.has(key)) {
      return <span className="sc-detail-table__text">{formatDateTime(value)}</span>;
    }

    if (key === "status") {
      const rawStatus = String(value);
      const mappedStatus = statusLabels[rawStatus] ?? rawStatus;
      return <span className="sc-detail-table__text">{mappedStatus}</span>;
    }

    return <span className="sc-detail-table__text">{String(value)}</span>;
  };

  return (
    <div className="sc-detail-table-shell sc-detail-table-shell--main">
      <h5 className="sc-detail-table__section-title">Szczegóły</h5>

      <Table size="sm" className="sc-detail-table mb-0">
        <tbody>
          {detailRows.map((row) => (
            <tr key={row.key}>
              <td className="sc-detail-table__label" data-label="Pole">{row.label}</td>
              <td className="sc-detail-table__value" data-label={row.label}>{resolveValue(row.key)}</td>
            </tr>
          ))}
        </tbody>
      </Table>
    </div>
  );
};

export default ScheduledChangeDetailData;